import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { CriteriaInfo } from '../../common/criteriaInfo'
import { selectCriteria } from '../../selectCriteria/store/slice'

export const SelectedCriteria = ({ autoHeight, autoHeightMax }) => {
  const criteria = useSelector(selectCriteria())

  return (
    <CriteriaInfo
      criteria={criteria}
      autoHeight={autoHeight}
      autoHeightMax={autoHeightMax}
    />
  )
}

SelectedCriteria.propTypes = {
  autoHeight: PropTypes.bool,
  autoHeightMax: PropTypes.number,
}

SelectedCriteria.defaultProps = {
  autoHeight: false,
  autoHeightMax: 0,
}
